export const expenseConstants = {
  CLOSE_ADD_EXPENSE_MODAL: 'CLOSE_ADD_EXPENSE_MODAL',
  OPEN_ADD_EXPENSE_MODAL: 'OPEN_ADD_EXPENSE_MODAL',
  GET_EXPENSE: 'GET_EXPENSE',
};
